import type { AccountFeature as GQLItem } from '../../../generated/api.graphql';

/**
 * api-layer.md gives every GraphQL type one mapper, so the feature list gets a domain type of
 * its own rather than collapsing to `string[]` inside `AccountConfig`.
 *
 * The rename is the point: the schema names a feature under `feature`, while the legacy type and
 * every `hasFeature('…')` call site in `@vp/admin` say `name`. Neither `id` nor `accountId` is
 * mapped — nothing reads them, and `currentUser.accountConfig` only ever resolves the caller's
 * own account, so every row would carry the same `accountId` anyway.
 */
export type AccountFeature = {
  name: string;
};

export const fromGql = (item: GQLItem): AccountFeature => ({ name: item.feature });
